// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Antd from "ant-design-vue/es";
import "ant-design-vue/dist/antd.css";
Vue.use(Antd);
import axios from 'axios';
Vue.prototype.$http= axios
// 注册全局变量
import app  from  './config/app'
Vue.prototype.app = app

Vue.prototype.HOST = 'http://ericgu178'
Vue.config.productionTip = false


import vcolorpicker from 'vcolorpicker'
Vue.use(vcolorpicker)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js